document.documentElement.classList.remove("no-js");

function shopbruddaToast(message) {
  const toast = document.querySelector("[data-toast]");
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add("is-visible");
  window.clearTimeout(window.shopbruddaToastTimer);
  window.shopbruddaToastTimer = window.setTimeout(() => toast.classList.remove("is-visible"), 2800);
}

document.querySelectorAll("[data-product-section]").forEach((section) => {
  const mainImage = section.querySelector("[data-main-image]");
  const galleryButtons = Array.from(section.querySelectorAll("[data-gallery-image]"));
  const productStage = section.querySelector(".sb-product-stage");
  let touchStartX = null;
  let galleryWheelLocked = false;

  function activateGalleryImage(button) {
    if (!button || !mainImage) return;
    mainImage.src = button.dataset.galleryImage;
    mainImage.alt = button.dataset.galleryAlt || "REDTIGER F17 product image";
    mainImage.classList.toggle("is-graphic", button.dataset.galleryKind === "graphic");
    mainImage.classList.toggle("is-product", button.dataset.galleryKind !== "graphic");
    galleryButtons.forEach((item) => item.classList.remove("is-active"));
    button.classList.add("is-active");
  }

  function moveGallery(direction) {
    const activeIndex = Math.max(0, galleryButtons.findIndex((button) => button.classList.contains("is-active")));
    const nextIndex = direction > 0
      ? (activeIndex + 1) % galleryButtons.length
      : (activeIndex - 1 + galleryButtons.length) % galleryButtons.length;
    activateGalleryImage(galleryButtons[nextIndex]);
  }

  galleryButtons.forEach((button) => {
    button.addEventListener("click", () => activateGalleryImage(button));
  });
  section.querySelectorAll("[data-gallery-direction]").forEach((button) => {
    button.addEventListener("click", () => moveGallery(button.dataset.galleryDirection === "next" ? 1 : -1));
  });

  productStage?.addEventListener("pointerdown", (event) => {
    if (event.target.closest?.("[data-gallery-image], [data-gallery-direction]")) {
      touchStartX = null;
      return;
    }
    touchStartX = event.clientX;
    if (window.matchMedia("(min-width: 981px)").matches) {
      productStage.setPointerCapture?.(event.pointerId);
      productStage.classList.add("is-dragging");
    }
  });
  productStage?.addEventListener("pointerup", (event) => {
    if (touchStartX === null) return;
    const distance = event.clientX - touchStartX;
    touchStartX = null;
    productStage.classList.remove("is-dragging");
    if (Math.abs(distance) <= 40) return;
    moveGallery(distance < 0 ? 1 : -1);
  });
  productStage?.addEventListener("pointercancel", () => {
    touchStartX = null;
    productStage.classList.remove("is-dragging");
  });
  productStage?.addEventListener("wheel", (event) => {
    if (!window.matchMedia("(min-width: 981px)").matches) return;
    if (Math.abs(event.deltaX) <= Math.abs(event.deltaY) || Math.abs(event.deltaX) < 18) return;
    event.preventDefault();
    if (galleryWheelLocked) return;
    galleryWheelLocked = true;
    moveGallery(event.deltaX > 0 ? 1 : -1);
    window.setTimeout(() => { galleryWheelLocked = false; }, 320);
  }, { passive: false });

  const form = section.querySelector(".sb-product-form");
  if (!form) return;
  const addButton = form.querySelector("[data-add-button]");
  const quantity = form.querySelector('input[name="quantity"]');
  form.querySelector("[data-quantity-minus]")?.addEventListener("click", () => {
    quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
  });
  form.querySelector("[data-quantity-plus]")?.addEventListener("click", () => {
    quantity.value = Math.min(9, Number(quantity.value || 1) + 1);
  });

  const variantSelect = form.querySelector("[data-variant-select]");
  variantSelect?.addEventListener("change", () => {
    const option = variantSelect.selectedOptions[0];
    const available = option.dataset.available === "true";
    const price = option.dataset.price || "";
    const compare = option.dataset.compare || "";
    const priceElement = section.querySelector("[data-price]");
    const compareElement = section.querySelector("[data-compare-price]");
    const buttonPrice = form.querySelector("[data-button-price]");
    if (priceElement) priceElement.textContent = price;
    if (buttonPrice) buttonPrice.textContent = price;
    if (compareElement) {
      compareElement.textContent = compare;
      compareElement.hidden = !compare || compare === price;
    }
    if (addButton) addButton.disabled = !available;
  });

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const buyNow = event.submitter?.matches?.("[data-mobile-buy-now]") || false;
    const purchaseButtons = Array.from(form.querySelectorAll("[data-add-button], [data-mobile-form-add], [data-mobile-buy-now]"));
    purchaseButtons.forEach((button) => { button.disabled = true; });
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form),
      });
      if (!response.ok) throw new Error("Unable to add this product.");
      if (buyNow) {
        window.location.assign(`${window.Shopify?.routes?.root || "/"}checkout`);
        return;
      }
      const cart = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`).then((result) => result.json());
      document.querySelectorAll("[data-cart-count]").forEach((count) => { count.textContent = cart.item_count; });
      document.querySelectorAll("[data-go-to-basket]").forEach((link) => { link.hidden = false; });
      shopbruddaToast("Added to your basket.");
    } catch (error) {
      shopbruddaToast(error.message || "Please try again.");
    } finally {
      purchaseButtons.forEach((button) => { button.disabled = false; });
    }
  });

  form.querySelector("[data-mobile-form-add]")?.addEventListener("click", () => form.requestSubmit(addButton));
  document.querySelector("[data-mobile-add]")?.addEventListener("click", () => form.requestSubmit(form.querySelector("[data-mobile-buy-now]")));
});
